import { Reveal } from "./Reveal";
import { Eyebrow } from "./Type";

export default function PageHeader({ eyebrow, title, intro, children }) {
  return (
    <section className="relative pt-36 md:pt-44 pb-16 md:pb-20 kv-radial overflow-hidden" data-testid="page-header">
      <div className="absolute inset-0 kv-grid-bg opacity-25" aria-hidden />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        {eyebrow && <Reveal><Eyebrow className="mb-6">{eyebrow}</Eyebrow></Reveal>}
        <Reveal delay={0.05}>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.03] text-kv-off max-w-4xl text-balance">
            {title}
          </h1>
        </Reveal>
        {intro && (
          <Reveal delay={0.12}>
            <p className="mt-6 font-body text-base md:text-lg text-kv-grey leading-relaxed max-w-2xl">{intro}</p>
          </Reveal>
        )}
        {children}
      </div>
    </section>
  );
}
